import { useTranslation } from 'react-i18next';
import { Hourglass } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { OrderPaymentHoldCode } from '@/lib/orders-client';

/**
 * Why cancelling or switching an unpaid order was refused, said where the operator pressed the
 * button. A toast alone vanishes while the charge is still settling, and the next thing they would
 * do is press the button again.
 */
export function PaymentHoldNotice({ code, className }: { code: OrderPaymentHoldCode; className?: string }) {
  const { t } = useTranslation('orders');

  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-300',
        className,
      )}
    >
      <Hourglass className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      {/* In progress now means a real charge the bank is still answering (uncharged sessions are
          released), so the notice says so rather than "try again in a few minutes". */}
      <p>{code === 'PAYMENT_IN_PROGRESS' ? t('paymentHold.inProgress') : t(`errors.${code}`)}</p>
    </div>
  );
}
